import Icon from '../components/Icon.vue'

Icon.register({
  'weight-hanging': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.3 445.9c8.3 33.3-14.7 66.1-46.3 66.1h-415.9c-31.7 0-54.6-32.8-46.3-66.1l73-292.1c3.8-15.2 16.4-25.7 30.9-25.7h60.3c-3.6-10-5.9-20.7-5.9-32 0-53 43-96 96-96 53 0 96 43 96 96 0 11.3-2.3 22-5.9 32h60.3c14.4 0 27.1 10.5 30.9 25.7zM256 128c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32z'
      }
    ]
  }
})
